<!--
  @author:chen.hao
  @time:2019/3/8
  @disc:ERP导入
 -->

<template>
  <div class="erp-import" @keyup.enter="enterSearch">
    <el-form ref="form" :model="form" inline class="table-search-bar">
      <el-form-item label="客户名称" prop="customerName">
        <el-input v-model="form.customerName" placeholder="请输入客户名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
        <el-button type="primary" @click="handleReset">重置</el-button>
      </el-form-item>
    </el-form>
    <el-tabs v-model="form.type" @tab-click="handleSearch">
      <el-tab-pane label="未导入" name="1"></el-tab-pane>
      <el-tab-pane label="已导入" name="2"></el-tab-pane>
    </el-tabs>
    <el-table
      :data="list"
      style="width: 100%"
      tooltip-effect="light">
      <el-table-column
        prop="custumerName"
        label="客户姓名"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="orgName"
        label="经营组织"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="accountsReceivable"
        label="应收账款（元）"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="rcvTranProc"
        label="应收事物处理-未核销（元）"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="rcvTranProcItf"
        label="应收事物处理-接口（元）"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="weiquxiao"
        label="未结算销售订单金额（元）"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="yukaidan"
        label="已结算销售订单金额（元）"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="baozhengjin"
        label="电商保证金（元）"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="creditLimit"
        label="信用额度（元）"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        label="操作"
        v-if="form.type==='1'">
        <template slot-scope="scope">
          <el-button type="text" @click="handleImport(scope.row)">导入</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :page-sizes="[10, 20, 50, 100]"
      :page-size="listState.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="listState.total"
      :current-page="listState.pageNo"
      background
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange">
    </el-pagination>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'erpImport',
  data () {
    return {
      form: {
        customerName: '',
        type: '1'
      }
    }
  },
  computed: {
    ...mapGetters({ list: 'getErpCusList', listState: 'getErpCusListState' })
  },
  methods: {
    ...mapActions(['getErpCusList', 'importErpCus', 'getCusTagArr']),
    enterSearch (e) { // 回车搜索
      if (e.target.form && e.target.nodeName === 'INPUT') {
        this.handleSearch()
      }
    },
    // 搜索
    handleSearch () {
      const params = { ...this.form, pageNo: 1 }
      this.getErpCusList(params)
    },
    // 分页条数变更
    handleSizeChange (val) {
      this.getErpCusList({ pageSize: val, pageNo: 1 })
    },
    // 分页跳转
    handleCurrentChange (val) {
      this.getErpCusList({ pageNo: val })
    },
    // 查询表单，表格重置
    handleReset () {
      this.$refs.form.resetFields()
      this.handleSearch()
    },
    // 导入
    handleImport (row) {
      this.$confirm('是否确认导入', '导入', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await this.importErpCus({ ...row })
        // await this.getCusTagArr()
        this.$message.success('客户资金余额同步成功')
        // 临时解决导入后加载列表loading不出现问题
        setTimeout(() => {
          this.handleSearch()
        }, 500)
      })
        .catch(() => {})
    }
  },
  mounted () {
    this.handleSearch()
  }
}
</script>

<style scoped>

</style>
